import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

const RequisitionVsProduction = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [inputs, setInputs] = useState({
    from_date: getTodayDate(),
    to_date: getTodayDate(),
    receipt_no: "",
  });

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  const fetchData = () => {
    setLoading(true);
    const params = new URLSearchParams();

    if (inputs.from_date) params.append("from_date", inputs.from_date);
    if (inputs.to_date) params.append("to_date", inputs.to_date);
    if (inputs.receipt_no && inputs.receipt_no.trim() !== "") {
      params.append("receipt_no", inputs.receipt_no.trim());
    }

    Http.get(`/requisition-vs-production-report?${params.toString()}`)
      .then((res) => {
        setReportData(res.data?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching requisition vs production report:", error);
        showAlert("Error fetching requisition vs production report", "danger");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  useEffect(() => {
    if (!location.state) return;
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const columns = useMemo(
    () => [
      { field: "created_by", header: "Kitchen" },
      { field: "receipt_no", header: "Requisition No" },
      { field: "requisition_date", header: "Requisition Date" },
      { field: "product_group_name", header: "Product Group" },
      { field: "requested_batch_size", header: "Requested Batch Size" },
      { field: "production_batch_size", header: "Production Batch Size" },
      { field: "production_count", header: "Production Records" },
      { field: "difference", header: "Difference" },
    ],
    []
  );

  const handleSearch = () => {
    fetchData();
  };

  const handleClear = () => {
    setInputs({
      from_date: getTodayDate(),
      to_date: getTodayDate(),
      receipt_no: "",
    });
    setTimeout(fetchData, 100);
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Requisition Vs Production Report</h5>
        </div>

        <div className="am-pagebody">
          <Alert alert={alert} />

          <div className="card pd-sm-40">
            <div className="row g-3">
              <div className="col-lg-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  name="from_date"
                  value={inputs.from_date}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <div className="col-lg-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  name="to_date"
                  value={inputs.to_date}
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <div className="col-lg-4">
                <label className="form-label">Requisition No</label>
                <input
                  type="text"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Search by requisition no"
                />
              </div>
              <div className="col-lg-2 d-flex align-items-end">
                <div className="w-100 d-flex gap-2">
                  <button
                    className="btn btn-primary btn-block"
                    onClick={handleSearch}
                    disabled={loading}
                  >
                    <i className="fa fa-search mg-r-10"></i>
                    {loading ? "Searching..." : "Search"}
                  </button>
                  <button
                    className="btn btn-secondary btn-block"
                    onClick={handleClear}
                    disabled={loading}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="card pd-20 pd-sm-40 mt-4">
            <h5 className="card-body-title">Requisition Vs Production</h5>
            <hr />
            <ReactDataTable cols={columns} receiveData={reportData} isLoading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequisitionVsProduction;
